/**
 * Analytics Reducer
 * =================
 * PURPOSE: Manage Redux state for analytics data
 * 
 * STATE STRUCTURE:
 *   transactionVolume: { loading, data, error }
 *   revenue: { loading, data, error }
 *   userGrowth: { loading, data, error }
 *   realTimeStats: { loading, data, error }
 *   clubPerformance: { loading, data, error }
 * 
 * WHY: Separates concerns for each analytics endpoint, allowing
 *      independent loading states and error handling.
 */

import {
    ANALYTICS_TRANSACTION_VOLUME_REQUEST,
    ANALYTICS_TRANSACTION_VOLUME_SUCCESS,
    ANALYTICS_TRANSACTION_VOLUME_FAIL,
    ANALYTICS_REVENUE_REQUEST,
    ANALYTICS_REVENUE_SUCCESS,
    ANALYTICS_REVENUE_FAIL,
    ANALYTICS_USER_GROWTH_REQUEST,
    ANALYTICS_USER_GROWTH_SUCCESS,
    ANALYTICS_USER_GROWTH_FAIL,
    ANALYTICS_REALTIME_REQUEST,
    ANALYTICS_REALTIME_SUCCESS,
    ANALYTICS_REALTIME_FAIL,
    ANALYTICS_CLUB_PERFORMANCE_REQUEST,
    ANALYTICS_CLUB_PERFORMANCE_SUCCESS,
    ANALYTICS_CLUB_PERFORMANCE_FAIL,
    ANALYTICS_RESET
} from '../constants/analyticsConstants';

// Transaction Volume Reducer
export const transactionVolumeReducer = (state = { loading: false, data: null }, action) => {
    switch (action.type) {
        case ANALYTICS_TRANSACTION_VOLUME_REQUEST:
            return { loading: true, data: state.data };
        case ANALYTICS_TRANSACTION_VOLUME_SUCCESS:
            return { loading: false, data: action.payload };
        case ANALYTICS_TRANSACTION_VOLUME_FAIL:
            return { loading: false, error: action.payload };
        case ANALYTICS_RESET:
            return { loading: false, data: null };
        default:
            return state;
    }
};

// Revenue Analytics Reducer
export const revenueAnalyticsReducer = (state = { loading: false, data: null }, action) => {
    switch (action.type) {
        case ANALYTICS_REVENUE_REQUEST:
            return { loading: true, data: state.data };
        case ANALYTICS_REVENUE_SUCCESS:
            return { loading: false, data: action.payload };
        case ANALYTICS_REVENUE_FAIL:
            return { loading: false, error: action.payload };
        case ANALYTICS_RESET:
            return { loading: false, data: null };
        default:
            return state;
    }
};

// User Growth Reducer
export const userGrowthReducer = (state = { loading: false, data: null }, action) => {
    switch (action.type) {
        case ANALYTICS_USER_GROWTH_REQUEST:
            return { loading: true, data: state.data };
        case ANALYTICS_USER_GROWTH_SUCCESS:
            return { loading: false, data: action.payload };
        case ANALYTICS_USER_GROWTH_FAIL:
            return { loading: false, error: action.payload };
        case ANALYTICS_RESET:
            return { loading: false, data: null };
        default:
            return state;
    }
};

// Real-time Stats Reducer
export const realTimeStatsReducer = (state = { loading: false, data: null }, action) => {
    switch (action.type) {
        case ANALYTICS_REALTIME_REQUEST:
            return { loading: true, data: state.data };
        case ANALYTICS_REALTIME_SUCCESS:
            return { loading: false, data: action.payload };
        case ANALYTICS_REALTIME_FAIL:
            return { loading: false, error: action.payload };
        case ANALYTICS_RESET:
            return { loading: false, data: null };
        default:
            return state;
    }
};

// Club Performance Reducer
export const clubPerformanceReducer = (state = { loading: false, data: null }, action) => {
    switch (action.type) {
        case ANALYTICS_CLUB_PERFORMANCE_REQUEST:
            return { loading: true, data: state.data };
        case ANALYTICS_CLUB_PERFORMANCE_SUCCESS:
            return { loading: false, data: action.payload };
        case ANALYTICS_CLUB_PERFORMANCE_FAIL:
            return { loading: false, error: action.payload };
        case ANALYTICS_RESET:
            return { loading: false, data: null };
        default:
            return state;
    }
};
